// extracted by mini-css-extract-plugin
module.exports = {"filters":"vehicle_filters__17aps","actions":"vehicle_actions__x03HC","importIcon":"vehicle_importIcon__2qFxl","table":"vehicle_table__1C9rf"};